var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeviceManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.828 1.47656H1.17175C0.525659 1.47656 -0.00012207 2.00234 -0.00012207 2.64844V14.2891C-0.00012207 14.9352 0.525659 15.4609 1.17175 15.4609H18.828C19.4741 15.4609 19.9999 14.9352 19.9999 14.2891V2.64844C19.9999 2.00234 19.4741 1.47656 18.828 1.47656Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2499 18.3516H13.0858V16.6328H6.91394V18.3516H3.74988C3.42644 18.3516 3.16394 18.6141 3.16394 18.9375C3.16394 19.2609 3.42644 19.5234 3.74988 19.5234H16.2499C16.5733 19.5234 16.8358 19.2609 16.8358 18.9375C16.8358 18.6141 16.5733 18.3516 16.2499 18.3516Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceManagement);
export default __webpack_public_path__ + "static/media/ICON_DEVICE_MANAGEMENT.8ade3f0aae596d95758795a75aaba3d1.svg";
export { ForwardRef as ReactComponent };